import axios from 'axios';
import apiUrl from '../../api-url';

// URLs
const WATCHLIST_URL = apiUrl('/preferences-ng/watchlist');

// Actions
export const RECEIVE_WATCHLIST = 'user/RECEIVE_WATCHLIST';

export function fetchWatchlist() {
  return dispatch => {
    return Promise.all([
      axios.get(`${WATCHLIST_URL}`)
    ])
      .then(responses => {
        dispatch({type: RECEIVE_WATCHLIST, data: responses[0].data})
      })
      .catch(err => {
        throw new Error(err);
      });
  };  
}


export function addWatchlistItem(part, location) {
  const payload = { 'part_value': part, 'location_id': location }
  return dispatch => {
    return Promise.all([
      axios.post(`${WATCHLIST_URL}`, payload)
    ])
      .then(responses => {
        dispatch(fetchWatchlist());
      })
      .catch(err => {
        throw new Error(err);
      });
  };  
}

export function editWatchlistItem(id, part, location) {
  const payload = { 'part_value': part, 'location_id': location }
  return dispatch => {
    return Promise.all([
      axios.put(`${WATCHLIST_URL}/${id}`, payload)
    ])
      .then(responses => {
        dispatch(fetchWatchlist());
      })
      .catch(err => {
        throw new Error(err);
      });
  };  
}

export function deleteWatchlistItem(id) {
  return dispatch => {
    return Promise.all([
      axios.delete(`${WATCHLIST_URL}/${id}`)
    ])
      .then(responses => {
        dispatch(fetchWatchlist());
      })
      .catch(err => {
        throw new Error(err);
      });
  };  
} 

const initialState = {
  watchlistData: []
};

function UserDataReducer(state = initialState, action = {}) {
  switch (action.type) {
    case RECEIVE_WATCHLIST:
      return {
        ...state,
        watchlistData: action.data
      };
   default:
      return state;
  }
}

export default UserDataReducer;



// WEBPACK FOOTER //
// ./src/modules/user-data/UserDataState.js